import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import VideoPlayer from '../../../components/VideoPlayer';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicPageVideoSection = ({
  creatorHubId,
  videoId
}) => {
  if (!creatorHubId) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    as: "section",
    "data-test-id": "public-page-video-section",
    paddingBlock: "1100",
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.previewVideo.watchPreview"
      })
    }), /*#__PURE__*/_jsx(VideoPlayer, {
      creatorHubId: creatorHubId,
      videoId: videoId
    })]
  });
};
export default PublicPageVideoSection;